exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#git-info{color:grey;display:flex;flex-direction:row;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b54419a6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?data=@import "./src/scss/base";!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/common/GitInfo.vue
// module id = 393
// module chunks = 1